var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
require("!!vue-style-loader!css-loader?sourceMap!vue-loader/lib/style-rewriter?id=data-v-645cdddc&scoped=true!vue-loader/lib/selector?type=styles&index=0!./ViewContract.vue")

/* script */
__vue_exports__ = require("!!babel-loader!vue-loader/lib/selector?type=script&index=0!./ViewContract.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-645cdddc!vue-loader/lib/selector?type=template&index=0!./ViewContract.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.__file = "C:\\Users\\Simona\\Source\\Repos\\TrackadoPoc\\TrackadoIntelligence\\wwwroot\\Scripts\\modules\\view-contract\\ViewContract.vue"
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-645cdddc"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-645cdddc", __vue_options__)
  } else {
    hotAPI.reload("data-v-645cdddc", __vue_options__)
  }
})()}
if (__vue_options__.functional) {console.error("[vue-loader] ViewContract.vue: functional components are not supported and should be defined in plain js files using render functions.")}

module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./Scripts/modules/view-contract/ViewContract.vue
// module id = 32
// module chunks = 1